import { render, staticRenderFns } from "./R27.vue?vue&type=template&id=58dac528&scoped=true"
import script from "./R27.vue?vue&type=script&lang=js"
export * from "./R27.vue?vue&type=script&lang=js"
import style0 from "./R27.vue?vue&type=style&index=0&id=58dac528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dac528",
  null
  
)

export default component.exports